import React from 'react';
import './Brand.css';

function Brand({ light = false }) {
  return <img className={`vanir-brand${light ? ' vanir-brand--light' : ''}`} src={`/images/brand/${light ? 'vmg-white' : 'vmg-logo'}.png`} width="800" height={light ? '257' : '262'} alt="Vanir Motor Group" />;
}

export default Brand;
